const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem("admin_token");

  const config = {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  };

  if (options.body && typeof options.body === "object") {
    config.body = JSON.stringify(options.body);
  }

  const res = await fetch(`${API_BASE}${endpoint}`, config);
  const data = await res.json();

  if (!res.ok) {
    const err = new Error(data.message || "API request failed");
    err.status = res.status;
    throw err;
  }

  return data;
}

/** Like apiFetch but sends FormData (multipart) — lets the browser set the
 *  Content-Type boundary. Used for image uploads. */
async function apiUpload(endpoint, formData, method = "POST") {
  const token = localStorage.getItem("admin_token");

  const res = await fetch(`${API_BASE}${endpoint}`, {
    method,
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  const data = await res.json();

  if (!res.ok) {
    const err = new Error(data.message || "API request failed");
    err.status = res.status;
    throw err;
  }

  return data;
}

/* ── Admin auth ──────────────────────────────── */
export const adminAuthAPI = {
  login: (email, password) =>
    apiFetch("/admin/login", { method: "POST", body: { email, password } }),
  getMe: () => apiFetch("/admin/me"),
};

/* ── User management ─────────────────────────── */
export const usersAPI = {
  getAll: (page = 1, limit = 10, search = "", filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      search,
    });
    if (filters.plan) params.set("plan", filters.plan);
    if (filters.status) params.set("status", filters.status);
    if (filters.premium) params.set("premium", filters.premium);
    return apiFetch(`/admin/users?${params.toString()}`);
  },
  update: (id, data) =>
    apiFetch(`/admin/users/${id}`, { method: "PUT", body: data }),
  remove: (id) =>
    apiFetch(`/admin/users/${id}`, { method: "DELETE" }),
};

/* ── Analytics ───────────────────────────────── */
export const analyticsAPI = {
  getOverview: (days = 30) =>
    apiFetch(`/admin/analytics/overview?days=${days}`),
  getExams: (days = 30) =>
    apiFetch(`/admin/analytics/exams?days=${days}`),
  getUsers: (days = 30) =>
    apiFetch(`/admin/analytics/users?days=${days}`),
  getRetention: (days = 30) =>
    apiFetch(`/admin/analytics/retention?days=${days}`),
};

/* ── Announcement entries ────────────────────── */
export const announcementEntriesAPI = {
  getAll: () => apiFetch("/admin/whats-new"),
  create: (formData) => apiUpload("/admin/whats-new", formData, "POST"),
  update: (id, formData) =>
    apiUpload(`/admin/whats-new/${id}`, formData, "PUT"),
  remove: (id) =>
    apiFetch(`/admin/whats-new/${id}`, { method: "DELETE" }),
};

/* ── App settings (exam schedule) ─────────────── */
export const settingsAPI = {
  getCseExamDate: () => apiFetch("/admin/settings/exam-date"),
  updateCseExamDate: (cseExamDate) =>
    apiFetch("/admin/settings/exam-date", {
      method: "PUT",
      body: { cseExamDate },
    }),
};

/* ── Announcement banner ─────────────────────── */
export const announcementAPI = {
  get: () => apiFetch("/admin/settings/announcement"),
  update: (text, enabled) =>
    apiFetch("/admin/settings/announcement", {
      method: "PUT",
      body: { text, enabled },
    }),
};
